import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';

export const getOrderDashboardMap = (searchQuery, filterByData) => {
  return api.post(URLS.orderDashboardMap, filterByData, {
    params: {
      ...(searchQuery && { query: searchQuery })
    },
    headers: {
      needsToken: true
    },
    responseType: 'arraybuffer'
  });
};
export const getOrderDashboardStats = () => {
  return api.get(URLS.getOrderDashboardStats, {
    headers: {
      needsToken: true
    }
  });
};
export const getOrderDashboardDateRangeFilters = () => {
  return api.get(URLS.orderDashboardDateRangeFilters, {
    headers: {
      needsToken: true
    }
  });
};
export const getOrderDashboardMilestoneStatusFilters = () => {
  return api.get(URLS.orderDashboardMilestoneStatusFilters, {
    headers: {
      needsToken: true
    }
  });
};
